// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"444":"e1a78a90","787":"500ac968"}[chunkId] + ".chunk.js";
};